import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import queryString from 'query-string';
import { message } from 'antd';
import { ddCodeApi, code2TokenApi, pageDetailApi } from '../../action';
import { AUTH_TOKEN_NAME } from '../../const';
import useEffectOnce from '../../utils/useEffectOnce';
import redirectUrl from "../../utils/redirectUrl";
import syncSubIframe from "../../utils/syncSubIframe";
import SsoUploadTrack from "../../utils/ssoUploadTrack";
import OtherLogin from "../login/otherLogin";
import { Spin } from 'antd';

interface LoginUrlParams {
    id?: string;
    code?: string;
    target?: string;
    state?: string;
    USER_TYPE?: string;
    sp?: string;
    [key: string]: any; 
}

const DdCallback = () => {
    const params: LoginUrlParams = queryString.parse(window.location.search.split('?')[1] || '');
    const navigate = useNavigate();

    useEffectOnce(() => {
        getPageInfo(getDdCode);
    });

    // 获取页面信息
    const getPageInfo = useCallback(async (callback: Function) => {
        const { id, target } = params;
        const res = await pageDetailApi({
            id,
            target: encodeURIComponent(target || ''),
            sp: ''
        });
        if (res.data.code === 0) {
            const { t_type } = res.data.data || {};
            if(t_type.includes('v1')){
                window.SSO_TOKEN_VERSION = 'v1';
            }
            if(t_type.includes('v2')){
                window.SSO_TOKEN_VERSION = 'v2';
            }
            callback && callback();
        } else {
            SsoUploadTrack('sso_page_info_error', {
                title: '单点登录子站信息获取失败',
                target_url: params.target || '',
                error_info: res.data.msg
            })
            navigate(`/error?info=子站信息获取失败,联系运维：${res.data.msg}`);
        }
    }, [params]);

    // code换token
    const getCode2Token = useCallback(async (code: string) => {
        const res = await code2TokenApi({
            code,
        });
        if (res.data.code === 0) {
            localStorage.setItem(`${AUTH_TOKEN_NAME}`, res.data.data);
            SsoUploadTrack('sso_page_login_success', {
                title: '单点登录成功',
                target_url: params.target || '',
                token: res.data.data,
                method: 'dd',
            });
            syncSubIframe(res.data.data, params.target, (target: string) => {
                if(OtherLogin.loginOtherSite({ target: params.target, sp: params.sp, id: params.id })){
                    redirectUrl({
                        target
                    });
                }
            });
        } else {
            SsoUploadTrack('sso_page_code2token_error', {
                title: '单点登录code换token失败',
                method: 'dd',
                target_url: params.target || '',
                error_info: res.data.msg
            })
            message.open({
                type: 'error',
                content: res.data.msg,
            });
        }
    }, [params]);

    const getDdCode = useCallback(async () => {
        const res = await ddCodeApi({
            dt_code: params.code || '',
            target: params.target || '',
            account_type: params.USER_TYPE === 'internal' ? 1 : 2,
            sp: params.sp || '',
            id: params.id || '',
        });
        if (res.data.code === 0) {
            getCode2Token(res.data?.data?.code);
        } else {
            SsoUploadTrack('sso_page_login_error', {
                title: '单点登录获取code失败',
                method: 'dd',
                target_url: params.target || '',
                error_info: res.data.msg
            })
            message.open({
                type: 'error',
                content: res.data.msg,
            });
        }
    }, [params, getCode2Token]);

    return <Spin size="large" style={{ width: '100vw', height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }} />
};

export default DdCallback;